// IE 2026 10 15 / ODOO-5800 (Igor 15.10, бой fe-2026-10-14-15, 1coh_001 «M03 Marketing plan · CF», скрин: после ✓ПМ у строки документа и клика по БЮМ левая
// панель замороженных колонок (названия строк, флаги) разъехалась со строками — подписи на несколько строк ниже чисел, часть строк слева пустые):
// у wijmo геометрия ячейки ЗАМОРОЖЕННОЙ колонки зависит от того, идёт ли правка (CellFactory.updateCell при cloneFrozenCells): без editRange
// top = row.pos + scrollY — настоящая ячейка под клоном уезжает вместе с прокруткой, а её копия в .wj-frozen-clone (клон не прокручивается)
// встаёт ровно на строку; с editRange top = row.pos, left = col.pos + scrollX — клон спрятан, настоящая ячейка видна в прокрученной панели.
// Ячейка, нарисованная в одном состоянии и НЕ перерисованная в другом (кэш-путь CustomCellFactory «уже отрисована в эпохе», точечный проход
// editKeep, прямой updateCell из editRefresh_cells / approvalPartial_refreshCells), остаётся с чужим top, а клон wijmo собирает копированием
// ячейки (_updateFrozenCells: cloneNode со style.top) — копия встаёт на scrollY ниже своей строки, её место пустое. Абсолютную геометрию
// пересчитать нельзя: поверх wijmo FE двигает top/left (разрывы секций breakTop, отступ дерева) — поэтому ячейка несёт ШТАМП состояния, в котором
// её считал wijmo (frozenCell_state на элементе), а правка — сдвиг между состояниями (frozenCell_delta): точный при любых добавках FE.
// Выключатель fe.ux.frozenCloneSync (дефолт ВКЛ; false — как до правки). Счётчик window.__frozenCloneSync {pass, fixed, cells, stale, skip}
export const FROZEN_CLONE_SYNC_FLAG = 'fe.ux.frozenCloneSync'
export const FROZEN_STAMP_KEY = '__fzState'

export function frozenCloneSync_flagOn(setting) {
    try { return typeof setting === 'function' ? setting(FROZEN_CLONE_SYNC_FLAG, true) !== false : true } catch (e) { return true }
}

const num = (v) => (Number.isFinite(v) ? v : 0)

// состояние, от которого зависит геометрия ячейки замороженной колонки: правка (flex.editRange) и прокрутка wijmo (scrollPosition: x, y ≤ 0)
export function frozenCell_state(editing, scroll) {
    return { edit: !!editing, sx: num(scroll && scroll.x), sy: num(scroll && scroll.y) }
}

// слагаемые top / left состояния по правилу wijmo CellFactory.updateCell (cloneFrozenCells, панель данных, строка не заморожена)
export function frozenCell_terms(state) {
    return state && state.edit ? { top: 0, left: -state.sx } : { top: state ? state.sy : 0, left: 0 }
}

// сдвиг top / left от состояния from к состоянию to; null — состояния нет
export function frozenCell_delta(from, to) {
    if (!from || !to) return null
    const a = frozenCell_terms(from), b = frozenCell_terms(to)
    return { top: b.top - a.top, left: b.left - a.left }
}

// применить сдвиг к style (px); true — что-то изменилось
export function frozenCell_shift(style, d) {
    if (!style || !d || (!d.top && !d.left)) return false
    if (d.top) style.top = ((parseFloat(style.top) || 0) + d.top) + 'px'
    if (d.left) style.left = ((parseFloat(style.left) || 0) + d.left) + 'px'
    return true
}

// клон замороженных: копии kids против оригиналов mains (тот же порядок — как строит wijmo _updateFrozenCells из querySelectorAll('.wj-frozen')).
// Копия показывается только без редактора, поэтому должна стоять как оригинал в состоянии «без правки» при текущей прокрутке cur. Копия со своим
// штампом (wijmo с DirectiveCellFactoryBase зовёт cellFactory.updateCell на КОПИИ — при editRange вся сборка клона уезжает на scrollTop: замер dev02
// 1coh_001, refreshRange при открытом editRange) — сдвиг её собственной геометрии; без него — top/left оригинала + сдвиг его штампа; без штампов — не
// трогаем. left — round (как wijmo). Возвращает число поправленных копий; −1 — клон не сходится с оригиналами (число / отсутствие), править нечего
export function frozenClone_fix(kids, mains, stampKey, cur, tol = 0.6) {
    if (!kids || !mains || !cur || kids.length !== mains.length) return -1
    const target = { edit: false, sx: cur.sx, sy: cur.sy }
    let fixed = 0
    for (let i = 0; i < kids.length; i++) {
        const c = kids[i], m = mains[i]
        if (!c || !c.style || !m || !m.style) continue
        const own = c[stampKey], st = own || m[stampKey]
        if (!st) continue
        const d = frozenCell_delta(st, target), src = own ? c.style : m.style
        if (!d) continue
        let hit = false
        const top = (parseFloat(src.top) || 0) + d.top
        if (!(Math.abs(parseFloat(c.style.top) - top) <= tol)) { c.style.top = top + 'px'; hit = true }
        const left = Math.round((parseFloat(src.left) || 0) + d.left)
        if (!(Math.abs(parseFloat(c.style.left) - left) <= tol)) { c.style.left = left + 'px'; hit = true }
        if (hit) { c[stampKey] = target; fixed++ }
    }
    return fixed
}
